import * as React from 'react';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Slide from '@mui/material/Slide';

export default function TranscriptionVideo({ src, transcription, onEnded }) {

    const containerRef = React.useRef(null);
    const [transcriptionVisible, setTranscriptionVisible] = React.useState(false);

    // Don't show anything when there is no video
    if (src === null || src.length === 0) {
        return null;
    }

    let videoSrc = '/data/' + src;
    if(src.indexOf('http') !== -1) {
        // When a link to mymedia is given get the video id from the url
        const regex = /\/[a-zA-Z0-9-]+-/g;
        let found = src.match(regex)[0];
        let myMediaId = found.substring(1, found.length-1);
        videoSrc = `https://cdn.jwplayer.com/videos/${myMediaId}-640.mp4`;
    }

    let smVideo = 9;
    let smTranscription = 3;
    let transcriptionDisplay = 'block';

    console.log(!transcription)

    // Remove the transcription part of the grid when there is no transcription
    if (!transcription || transcription.length == 0) {
        smVideo = 12;
        smTranscription = 0;
        transcriptionDisplay = 'none';
    }
    console.log(smTranscription)

    const videoEnded = () => {
        setTranscriptionVisible(true);
        if (onEnded != undefined) onEnded();
    }

    const scrollStyle={
        overflowY: 'scroll',
        height:'400px',
      };    

    let toggle = 0;
    let prevName ='';

    return (
        <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="stretch"
            mb={2}
        >
            <Grid key={"transcription_video_movie"} item xs={smVideo}>
                <video controls width="100%" onEnded={videoEnded}>
                    <source src={videoSrc} type="video/mp4" />
                    Sorry, your browser doesn't support videos.
                </video>
                <br/>
            </Grid>

            <Grid key={"transcription_video_transcription"} item xs={smTranscription} display={transcriptionDisplay}>
                <Slide direction="left" in={transcriptionVisible} container={containerRef.current}>
                    <Stack direction="column" spacing={1} style={scrollStyle} alignItems="flex-start">
                        {
                            (transcription ?? []).map((t, i) => {
                                let name = Object.keys(t)[0];
                                let text = t[name]
                                
                                
                                // line for testing
                                //let bgColor = (toggle %2 == 0) ? '#79C4D2' : '#B3DDE5';
                                if (prevName != name) {
                                    toggle++; 
                                }
                                prevName = name;
                                let bgColor = (toggle %2 == 0) ? '#0000E1' : '#00A1E1';
                                return <Chip 
                                    key={"trans_" + i+name} 
                                    avatar={<Avatar>{name}</Avatar>} 
                                    label={<Typography style={{ whiteSpace: 'normal' }}> {text} </Typography>} 
                                    style={{ height: "auto", backgroundColor: bgColor }}
                                    color='info'
                                />
                            })
                        }
                    </Stack>
                </Slide>
            </Grid>
        </Grid>
    );
}
